export function isLoopbackHostname(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === '[::1]'
}

export function isAllowedOtlpCorsOrigin(origin: string | null, appOrigin = ''): boolean {
  if (!origin) return false

  try {
    const url = new URL(origin)
    if (url.username || url.password || url.pathname !== '/' || url.search || url.hash) return false
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
    if (isLoopbackHostname(url.hostname)) return true
    if (!appOrigin) return false
    return origin === new URL(appOrigin).origin
  } catch (error) {
    void error
    return false
  }
}
